import React,{useEffect,useId,useRef,useState} from "react";
import {createPortal} from "react-dom";
import QuestionLayout from "./QuestionLayout";
import ScoreAnalysisFields from "./ScoreAnalysisFields";
import "./ScoreAnalysis.css";

export default function ScoreAnalysis({config,value={},onChange,mode="edit",feedback}) {
  const [open,setOpen]=useState(false),dialog=useRef(null),trigger=useRef(null),heading=useId();
  useEffect(()=>{
    if(!open)return;
    const previous=document.activeElement,overflow=document.body.style.overflow;
    document.body.style.overflow='hidden';
    const node=dialog.current;
    const focusable=()=>Array.from(node?.querySelectorAll('button,input,select,textarea,iframe,a[href],[tabindex="0"]') || []).filter(el=>!el.disabled);
    const first=focusable()[0];first?.focus();
    const keydown=event=>{
      if(event.key==='Escape'){event.preventDefault();event.stopPropagation?.();setOpen(false);}
      if(event.key==='Tab'){
        const items=focusable(),first=items[0],last=items.at(-1);
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last?.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first?.focus();}
      }
    };
    document.addEventListener('keydown',keydown,true);
    return ()=>{document.body.style.overflow=overflow;document.removeEventListener('keydown',keydown,true);(trigger.current || previous)?.focus?.();};
  },[open]);
  const fields=<ScoreAnalysisFields config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>;
  const score=config.scorePdfUrl || '';
  const pdfSource=score.includes('#')?score:score+'#view=FitH&toolbar=1&navpanes=0';
  return <>
    <QuestionLayout number={config.number} prompt={config.prompt} points={config.points} mode={mode} feedback={feedback}>
      <div className="score-analysis-question">
        <button type="button" ref={trigger} className="score-analysis-view" onClick={()=>setOpen(true)}>View Score</button>
        {fields}
      </div>
    </QuestionLayout>
    {open&&typeof document!=='undefined'&&createPortal(
      <section ref={dialog} role="dialog" aria-modal="true" aria-labelledby={heading} className="score-analysis-modal">
        <header className="score-analysis-modal-header">
          <h2 id={heading}>{config.scoreTitle || `Question ${config.number} score`}</h2>
          <button type="button" aria-label="Close score viewer" onClick={()=>setOpen(false)}>Close</button>
        </header>
        <div className="score-analysis-modal-body">
          <div className="score-analysis-pdf">
            {score?<iframe title="Score PDF" src={pdfSource}/>:<p>The score has not been added yet.</p>}
          </div>
          <div className="score-analysis-answer-panel">
            <h3>Question {config.number}</h3>
            <ScoreAnalysisFields config={config} value={value} onChange={onChange} mode={mode} feedback={feedback}/>
          </div>
        </div>
      </section>,document.body)}
  </>;
}
